import { deref } from "kanopi-components/utils/primitives";
import { useGlobal } from "kanopi-components/useGlobal";

import { useGlobalsContext } from "../../Globals";
import { useAnswerEnquiry } from "../../useAnswerEnquiry";
import { useStartCoverSummary } from "../useStartCoverSummary";

type TUseCoverSummaryProcessArgs = {
  coverId: string;
  riskProfileId: string;
};

type TUseCoverSummaryProcess = [
  TQuestionSet,
  (answers: TODO) => Promise<TODO>,
  TRiskData,
  {
    loading: boolean;
    saving: boolean;
  }
];

export function useCoverSummaryProcess(
  args: TUseCoverSummaryProcessArgs
): TUseCoverSummaryProcess {
  const globalDataKey = useGlobalsContext();
  const [data, setData] = useGlobal(globalDataKey);
  const { coverId, riskProfileId } = args;

  const {
    enquiry: startEnquiry = {},
    loading: coverLoading,
    refetch,
  } = useStartCoverSummary({ coverId, riskProfileId, globalDataKey });

  const [answerEnquiry, , { loading: answerSaving }] = useAnswerEnquiry({
    coverId,
    globalDataKey,
  });

  const questionSet = startEnquiry.questionSet;
  const answerCurrentEnquiry = async (answers) => {
    const questionFlowId = startEnquiry?.questionFlow?.id;
    await answerEnquiry(questionFlowId, answers);
    setData({ reprice: true });
    refetch(true);
  };

  const riskProfile = data?.riskProfile;
  const riskData = deref(riskProfile, "riskData", {});

  return [
    questionSet,
    answerCurrentEnquiry,
    riskData,
    {
      loading: coverLoading,
      saving: answerSaving,
    },
  ];
}
